module.exports = __webpack_public_path__ + "img/logo.b746f0aa.png";